import React, {useEffect, useRef, useState} from 'react';
import {Card} from "primereact/card";
import {InputText} from "primereact/inputtext";
import {Dropdown} from "primereact/dropdown";
import {FileUpload} from "primereact/fileupload";
import {Button} from "primereact/button";
import {InputTextarea} from "primereact/inputtextarea";
import "react-quill/dist/quill.snow.css";
import {webInfo} from "../../../utils/webInfo";
import callToast, {catchError, showErrors} from "../../../utils/helper";
import usePost from "../../../hooks/usePost";
import moment from "moment/moment";
import {Calendar} from "primereact/calendar";
import {Toast} from "primereact/toast";
import TextEditor from "../../../components/TextEditor";
import useApi from "../../../hooks/useApi";
import useStore from "../../../hooks/useStore";

const CreateNew = () => {
    const url = `${webInfo.baseUrl}/api/admin/companies`
    const toast:any = useRef<any>(null);
    const link = `${webInfo.baseUrl}/api/admin/careers`;
    const [description, setDescription] = useState('');
    const [jobRequirement, setJobRequirement] = useState('');
    const [educationRequirement, setEducationRequirement] = useState('');
    const [jobBenefits, setJobBenefits] = useState('');
    const [howToApply, setHowToApply] = useState('');
    const {post,loading} = usePost();
    const {user} = useStore()
    const {get} = useApi<any>();
    const [depots,setDepots] = useState([]);
    const [departments,setDepartments] = useState([]);
    const [career, setCareer] = useState<any>({
        title:"",
        short_description:"",
        address:"",
        image:"",
        company_id:0,
        company_department_id:0,
        files:[{id:1,name:"",file:null}],
        number_of_vacancy:"",
        salary_from:"",
        salary_to:"",
        job_type:"",
        expired_date:moment(new Date(), "YYYY-MM-DD HH:mm:ss").toDate(),
    });

    useEffect(() => {
        const fetchDepots = async () => {
            try {
                const res: any = await get(url);
                setDepots(res.data.data);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchDepots();
        // eslint-disable-next-line
    }, []);

    const handleInput = (e:any)=>{
        setCareer({
            ...career,
            [e.target.name]: e.target.value,
        })
    }
    const onUploadImage = (event: any) => {
        setCareer({
            ...career,
            image: event.files[0],
        })
    };

    const pdfName = (event: any,id:any) => {
        const item = career?.files?.map((item:any) => {
            if(Number(item.id)===Number(id)){
                return {
                    ...item,
                    [event.target.name]:event.target.value,
                }
            }
            return item;
        })
        setCareer({
            ...career,
            files:item,
        })
    };
    const onUploadPdf = (event: any,id:any) => {
        const item = career?.files?.map((item:any) => {
            if(Number(item.id)===Number(id)){
                return {
                    ...item,
                    file:event.files[0],
                }
            }
            return item;
        })
        setCareer({
            ...career,
            files:item,
        })
    };
    const onRemoveImage = () => {
        setCareer({
            ...career,
            image: "",
        });
    };

    const addCareer = async ()=>{
        const formData = new FormData();
        for (const key in career) {
            const value = career[key as keyof typeof career];

            if (key === "files" || key === "expired_date") continue;

            if (value !== null && value !== "") {
                if (key === "image" && value instanceof File) {
                    formData.append("image", value); // ✅ correct
                } else {
                    formData.append(key, value as any);
                }
            }
        }
        if (career.expired_date){
            const formatedData = moment(career.expired_date).format("YYYY-MM-DD")
            formData.append('expired_date', formatedData);
        }
        if (career?.documents?.length > 0) {
            career?.documents?.forEach((item:any,index:any)=>{
                if (typeof item.file!=="string"){
                    formData.append(`files[${index}][name]`,item?.name);
                    formData.append(`files[${index}][file]`,item?.file);
                }
            })
        }
        const editorValues = {
            description,
            job_requirement: jobRequirement,
            education_requirement: educationRequirement,
            how_to_apply: howToApply,
            job_benefits: jobBenefits
        };
        Object.entries(editorValues).forEach(([key, value]) => {
            if (value !== null && value.length > 0) {
                formData.append(key, value);
            }
        });
        formData.append("status", "0");
        // console.log(Object.fromEntries(formData.entries()));
        try {
            const res = await post(link,false,formData)
            if (res.success){
                callToast(toast,true,res.data.message)
            }else {
                console.log(res.error.errors)
                showErrors(res.error.errors,toast);
            }
        }catch (error) {
            catchError(error)
        }
    }

    const addDoc = ()=>{
        const id = career?.files?.length > 0 ? career?.files?.at(-1)?.id : 0;
        setCareer({
            ...career,
            files:[
                ...career.files,
                {
                    id:id+1,
                    name:"",
                    file:null
                }
            ]
        })
    }

    const handleChange = (e: any) => {
        setCareer({
            ...career,
            [e.target.name]: e.target.value,
        })
    }

    const header = (
        <div className="flex align-items-center justify-content-between p-4 pb-0">
            <h4 className="m-0">New Career</h4>
        </div>
    )

    const conditionalDepartment: any =
        Number(user?.role) === 2
            ? departments?.filter(
                (item: any) =>
                    item?.name === "Sales" || item?.name === "Marketing"
            )
            : departments;

    return (
        <Card header={header}>
            <Toast ref={toast}/>
            <div className="grid">
                {/* LEFT SIDE – PRODUCT INFO (7 COLS) */}
                <div className="col-12 md:col-7">
                    <div className="pr-2">
                        <div className="p-fluid grid">
                            {/* Product Name */}
                            <div className="col-12 md:col-12">
                                <label className="font-medium">Title *</label>
                                <InputText
                                    name={'title'}
                                    onChange={handleInput}
                                    value={career.title}
                                    placeholder="Enter career title"
                                />
                            </div>
                            <div className="col-12 md:col-6">
                                <label className="font-medium">Division *</label>
                                <Dropdown
                                    options={depots?.map((item:any)=>{
                                        return {
                                            name:item?.name,
                                            code:item?.id,
                                        }
                                    })}
                                    value={depots?.map((item: any) => ({name: item?.name, code: item?.id})).find((item: any) => Number(item?.code) === Number(career.company_id))}
                                    onChange={(e:any)=>{
                                        setCareer({
                                            ...career,
                                            company_id: e.target.value.code,
                                        })
                                        const found:any = depots?.find((item: any) => Number(item?.id) === Number(e.target.value.code))
                                        if (found?.id){
                                            const deptOps = found?.departments?.map((item:any)=>({name:item?.name,code:item?.id}))
                                            setDepartments(deptOps)
                                        }else{
                                            setDepartments([])
                                        }
                                    }}
                                    optionLabel="name"
                                    placeholder="Select Depot"
                                />
                            </div>
                            <div className="col-12 md:col-6">
                                <label className="font-medium">Department *</label>
                                <Dropdown
                                    options={conditionalDepartment || []}
                                    value={departments?.find((item:any)=>Number(item?.code)===Number(career.company_department_id))}
                                    onChange={(e)=>{
                                        setCareer({
                                            ...career,
                                            company_department_id: e.target.value.code,
                                        })
                                    }}
                                    optionLabel="name"
                                    placeholder="Select Department"
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label className="font-medium">Salary From *</label>
                                <InputText
                                    name={'salary_from'}
                                    onChange={handleInput}
                                    type={"number"}
                                    value={career.salary_from}
                                    placeholder="BDT 00.00"
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label className="font-medium">Salary To *</label>
                                <InputText
                                    type={"number"}
                                    value={career.salary_to}
                                    name={'salary_to'}
                                    onChange={handleInput}
                                    placeholder="BDT 00.00"
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label className="font-medium">Job Type *</label>
                                <InputText
                                    value={career.job_type}
                                    placeholder="Job Type"
                                    name={'job_type'}
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label className="font-medium">Vacancy *</label>
                                <InputText
                                    value={career.number_of_vacancy}
                                    placeholder="Enter product name"
                                    name={'number_of_vacancy'}
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label className="font-medium">Location *</label>
                                <InputText
                                    value={career.address}
                                    placeholder="Location"
                                    name={'address'}
                                    onChange={handleInput}
                                />
                            </div>
                            <div className="col-12 md:col-4">
                                <label className="font-medium">Expired Date</label>
                                <Calendar value={career?.expired_date} onChange={(e: any) => {
                                    setCareer({
                                        ...career,
                                        expired_date:e.value,
                                    })
                                }} placeholder={'Event date'}/>
                            </div>

                            <div className="col-12 md:col-12">
                                <label className="font-medium">Short Description *</label>
                                <InputTextarea
                                    style={{height:'150px'}}
                                    value={career.short_description}
                                    placeholder="Enter product name"
                                    name={'short_description'}
                                    onChange={handleInput}
                                />
                            </div>

                            <div className="col-12 md:col-12">
                                <label className="font-medium">Description *</label>
                                {/*<TinyEditor*/}
                                {/*    value={description}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setDescription(content)*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={description || ''}
                                    setValue={(content: string) =>
                                        setDescription(content)
                                    }
                                />
                                {/*<Editor value={description} onTextChange={(e:any)=>setDescription(e.htmlValue)} className='w-100' style={{ height: '320px' }} />*/}
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Requirement *</label>
                                {/*<TinyEditor*/}
                                {/*    value={jobRequirement}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setJobRequirement(content)*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={jobRequirement || ''}
                                    setValue={(content: string) =>
                                        setJobRequirement(content)
                                    }
                                />
                                {/*<Editor value={jobRequirement} onTextChange={(e:any)=>setJobRequirement(e.htmlValue)} className='w-100' style={{ height: '320px' }} />*/}
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Education Requirement *</label>
                                {/*<TinyEditor*/}
                                {/*    value={educationRequirement}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setEducationRequirement(content)*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={educationRequirement || ''}
                                    setValue={(content: string) =>
                                        setEducationRequirement(content)
                                    }
                                />
                                {/*<Editor value={educationRequirement} onTextChange={(e:any)=>setEducationRequirement(e.htmlValue)} className='w-100' style={{ height: '320px' }} />*/}
                            </div>

                            <div className="col-12">
                                <label className="font-medium">Job Benefits *</label>
                                {/*<TinyEditor*/}
                                {/*    value={jobBenefits}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setJobBenefits(content)*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={jobBenefits || ''}
                                    setValue={(content: string) =>
                                        setJobBenefits(content)
                                    }
                                />
                                {/*<Editor value={jobBenefits} onTextChange={(e:any)=>setJobBenefits(e.htmlValue)} className='w-100' style={{ height: '320px' }} />*/}
                            </div>

                            <div className="col-12">
                                <label className="font-medium">How to Apply *</label>
                                {/*<TinyEditor*/}
                                {/*    value={howToApply}*/}
                                {/*    onChange={(content: string) =>*/}
                                {/*        setHowToApply(content)*/}
                                {/*    }*/}
                                {/*/>*/}
                                <TextEditor
                                    value={howToApply || ''}
                                    setValue={(content: string) =>
                                        setHowToApply(content)
                                    }
                                />
                                {/*<Editor value={howToApply} onTextChange={(e:any)=>setHowToApply(e.htmlValue)} className='w-100' style={{ height: '320px' }} />*/}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-12 md:col-5">
                    <div className="pl-2">
                        <div className="col-12">
                            <label className="font-medium">Thumbnail Image (686 x 357 || 1024 kB max)</label>
                            <FileUpload
                                name="image"
                                url="/api/upload"
                                multiple={false}
                                accept="image/*"
                                maxFileSize={1024*1024}
                                onSelect={onUploadImage}
                                onRemove={onRemoveImage}
                            />

                        </div>

                        {/* Product PDF */}
                        <div className="col-12">
                            <div className="flex justify-content-between mt-4 mb-2">
                                <h4 className="mb-0">Document</h4>
                                <Button onClick={addDoc} icon={'pi pi-plus'} size={'small'} label={'Add New'} outlined />
                            </div>
                            {
                                career?.files?.map((item:any)=>{
                                    return <Card key={item.id} className="mb-2">
                                        <div className={'mb-2'}>
                                            <label className="font-medium">File name</label>
                                            <InputText onChange={(e)=>pdfName(e,item.id)} className='w-full mb-2' placeholder={'File Name'} value={item.name} name={'name'}/>
                                        </div>
                                        <div>
                                            <label className="font-medium">File (1024 kB max / File)</label>
                                            <FileUpload
                                                name="details_pdf"
                                                url="/api/upload"
                                                multiple={false}
                                                accept="application/pdf"
                                                maxFileSize={10*1024*1024}
                                                onSelect={(e:any)=>onUploadPdf(e,item.id)}
                                            />
                                        </div>
                                        <Button onClick={()=>{
                                            const remainfiles = career.files.filter((item2:any)=>Number(item2.id)!==Number(item.id))
                                            setCareer({
                                                ...career,
                                                files:remainfiles
                                            })
                                        }} outlined label={'Remove'} size={'small'} severity={'danger'} className='mt-2' icon={'pi pi-minus'}/>
                                    </Card>
                                })
                            }
                        </div>
                    </div>

                    <div className="grid p-4">
                        <div className="col-12">
                            <h4 className="mb-3">SEO Information</h4>
                        </div>

                        {/* Meta Title */}
                        <div className="col-12">
                            <label className="font-medium">Meta Title</label>
                            <InputText
                                name="meta_title"
                                value={career.meta_title || ""}
                                onChange={handleChange}
                                placeholder="Meta Title"
                                className="w-full"
                            />
                        </div>

                        {/* Meta Author */}
                        <div className="col-12 md:col-6">
                            <label className="font-medium">Meta Author</label>
                            <InputText
                                name="meta_author"
                                value={career.meta_author || ""}
                                onChange={handleChange}
                                placeholder="Meta Author"
                                className="w-full"
                            />
                        </div>

                        {/* Meta Robots */}
                        <div className="col-12 md:col-6">
                            <label className="font-medium">Meta Robots</label>
                            <Dropdown
                                value={career.meta_robots || ""}
                                options={[
                                    { label: "Index, Follow", value: "index, follow" },
                                    { label: "No Index, Follow", value: "noindex, follow" },
                                    { label: "Index, No Follow", value: "index, nofollow" },
                                    { label: "No Index, No Follow", value: "noindex, nofollow" }
                                ]}
                                onChange={(e) =>
                                    setCareer({ ...career, meta_robots: e.value })
                                }
                                placeholder="Select Robots Option"
                                className="w-full"
                            />
                        </div>

                        {/* Meta Description */}
                        <div className="col-12">
                            <label className="font-medium">Meta Description</label>
                            <InputTextarea
                                name="meta_description"
                                value={career.meta_description || ""}
                                onChange={handleChange}
                                rows={4}
                                placeholder="Meta Description"
                                className="w-full"
                                autoResize
                            />
                        </div>

                        {/* Meta Keywords */}
                        <div className="col-12">
                            <label className="font-medium">Meta Keywords</label>
                            <InputText
                                name="meta_keywords"
                                value={career.meta_keywords || ""}
                                onChange={handleChange}
                                placeholder="keyword1, keyword2, keyword3"
                                className="w-full"
                            />
                        </div>

                        {/* Tags */}
                        <div className="col-12">
                            <label className="font-medium">Tags</label>
                            <InputText
                                name="tags"
                                value={career.tags || ""}
                                onChange={handleChange}
                                placeholder="tag1, tag2, tag3"
                                className="w-full"
                            />
                        </div>

                        {/* Meta Image Upload */}
                        <div className="col-12">
                            <label className="font-medium">Meta Image (686 x 357 || 1024 kB max)</label>
                            <FileUpload
                                name="demo[]"
                                url="/api/upload"
                                multiple={false}
                                accept="image/*"
                                maxFileSize={1024*1024}
                                // emptyTemplate={defaultMetaImagePreviewer}
                                // onSelect={onMetaUpload}
                                // onRemove={onMetaRemove}
                            />
                        </div>
                    </div>
                </div>

                {/* ACTION BUTTONS */}
                <div className="col-12 flex justify-content-end gap-2 mt-3">
                    <Button label="Back" icon={"pi pi-chevron-left"} className="p-button-secondary" />
                    <Button loading={loading} onClick={addCareer} label="Create Career" icon="pi pi-check" />
                </div>
            </div>
        </Card>
    );
};

export default CreateNew;